import { matchPath } from 'react-router-dom';

import { ORDER_ROUTES } from '../order/order.constants';
import { PAYMENT_ROUTES } from '../payment/payment.constants';
import { EVENT_NAMES, EventName } from './event-log.constants';

/**
 * Maps a route pattern to its `page hidden - {screen}` event name (SWRN-1639,
 * A3). Only the "linger" screens — where a user waits and can background the
 * tab mid-flow — are listed; terminal, feedback, service and scan screens are
 * intentionally absent (a hide there carries no drop-off signal).
 */
const PATH_TO_PAGE_HIDDEN: ReadonlyArray<readonly [string, EventName]> = [
    [ORDER_ROUTES.connecting, EVENT_NAMES.pageHidden['connecting']],
    [PAYMENT_ROUTES.select, EVENT_NAMES.pageHidden['select']],
    [PAYMENT_ROUTES.snack, EVENT_NAMES.pageHidden['snack']],
    [PAYMENT_ROUTES.water, EVENT_NAMES.pageHidden['water']],
    [PAYMENT_ROUTES.pulse, EVENT_NAMES.pageHidden['pulse']],
    [PAYMENT_ROUTES.carWash, EVENT_NAMES.pageHidden['car-wash']],
    [PAYMENT_ROUTES.popcorn, EVENT_NAMES.pageHidden['popcorn']],
    [PAYMENT_ROUTES.payment, EVENT_NAMES.pageHidden['payment']],
    [PAYMENT_ROUTES.paymentCT5, EVENT_NAMES.pageHidden['payment-ct5']],
    [PAYMENT_ROUTES.paymentCT10, EVENT_NAMES.pageHidden['payment-ct10']],
    [PAYMENT_ROUTES.wait, EVENT_NAMES.pageHidden['wait-screen']],
];

/**
 * Resolves the current pathname to a `page hidden - {screen}` event name, or
 * `null` for screens we don't track hides on.
 */
export function screenFromPath(pathname: string): EventName | null {
    const match = PATH_TO_PAGE_HIDDEN.find(([pattern]) =>
        matchPath(pattern, pathname),
    );
    return match ? match[1] : null;
}
